import utils from './utils';

import slider from './components/slider';
import menu from './components/menu';
import imgtosvg from './components/imgtosvg';
import lazyload from './components/lazy-load';

// import modal from './components/modal';
import scroll from './components/scroll';
import mailchimp from './components/mailchimp';
import video from './components/video';
import map from './components/map';
import accordions from './components/accordions';

import entry_animations from './components/entry-animations';


function initHiPriorityCommon() {
    imgtosvg.initImgtosvg();
	lazyload.initImages();
    // modal.init();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        mailchimp.init();
        
    }, 1000);
}

function initPage() {
    slider.initSlider();
    menu.initMenu();
    scroll.initScroll();
    video.init();
	map.initGoogleMap();
    accordions.initAccordions();
    entry_animations.initEntryAnimations();

    // initFullPage();
    // initOverlay();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});

window.addEventListener('load', function () {
    //loadScript('https://cdn.iubenda.com/iubenda.js', false, null);
    //injectsmxConsole();
});